import React from "react";
import { CoreComponent } from "../core/CoreComponent";
import { Apiserver } from "../core/Apiserver";
import { log, Validator, getValue } from "../core/Util";
import { DBConstants, ErrorMsg } from "../core/Constants";
import { BannerBar } from "../core/MenuBar";

export class SetupPwdWithEmail extends CoreComponent {

  constructor(props) {
    super(props);

    if (props.location && props.location.data) {
      this.state.email = props.location.data.emailid
    }

  }

  handleButtonClick = () => {
    this.props.history.push("/login");
  }

  resendEmail = () => {
    this.postdata()
  }

  async postdata() {

    let datain = {}
    datain[DBConstants.Email_ID] = this.state.email
    datain[DBConstants.SIGNUP_LINK_TYPE] = this.props.location.data[DBConstants.SIGNUP_LINK_TYPE]

    this.showAnimation();
    let response = await Apiserver.postcall("send_signup_link", datain);
    this.closeAnimation();

    let error = {};
    if (!Validator.checkResponseData(response, error)) {
      this.setState({ error: error });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      this.redirectWithMessageAndData(this.props, "/setuppwd", "Email link resent again!", datain)
    }

  }

  render() {
    return (
      <div className="d-flex flex-row m0 p0 hfull backimg justify-content-center">
        <div className="col col-lg-5 col-md-6 col-s-12 fs15 m20 mt30 p0 formborder justify-content-center mh500">
          <BannerBar />
          <div className="mt20 ml10 mr10">
            <label htmlFor="username" className="form-label">
              As you are logging in for the first time, we have send you a link to your email id
            (<span className="fcmaroon">{this.state.email && this.state.email}</span>) to setup a password.</label>
            <label> Please click on the link and complete your password setup process.</label>
            <label>If you haven’t received your email please check your junk/spam folder. </label>
            <label>
              <span
                className="clickablelink fs12"
                style={{ padding: "5px", margin: "0px" }}
                onClick={() => this.resendEmail()}
              >
                You may click here to resend it again.
              </span>
            </label>
          </div>
          <div className="d-flex flex-row hc vc mt20 ml10 mr10">
            <button
              onClick={this.handleButtonClick}
              type="button"
              className=" btn btn-primary"
            >
              Back To Login
            </button>
          </div>
        </div>
      </div>
    );
  }
}
